import { ReponseSuivi } from '../../models/reponses/reponse-suivi';
import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseSuiviResiliation: ReponseEnveloppe<ReponseSuivi> = {
    'reponse': {
        'suiviResiliation' :
        {
            'status': 'Traitée',
            'label' :  'Résiliation de la ligne 06 00 00 00 00',
            'details':  '',
            'stepList':
            [
                {
                    'stepNumber': 0,
                    'status': 'PAST',
                    'primary': false,
                    'label': 'Enregistrement de votre demande de résiliation',
                    'details': '',
                    'type': 'RESILIATION_MOBILE',
                    'actionList': []
                },
                {
                    'stepNumber': 1,
                    'status': 'CURRENT',
                    'primary': true,
                    'label': 'Résiliation effective de votre ligne',
                    'details': 'Mer. 31 Mai 2023<br> Si vous changez d\'avis et souhaitez conserver votre ligne SFR, vous pouvez annuler votre demande de résiliation jusqu\'au Mar. 30 Mai',
                    'type': 'RESILIATION_MOBILE',
                    'actionList': [
                        {
                        'type': 'BUTTON',
                        'primary': true,
                        'label': 'Annuler votre demande',
                        'uri': '/annuler',
                        'details': 'null'
                        }
                    ]
                },
                {
                    'stepNumber': 2,
                    'status': 'FUTUR',
                    'primary': false,
                    'label': 'Facture de clôture',
                    'details': 'Dès la résiliation effective de votre ligne, retrouvez votre facture de clôture dans la rubrique Factures.',
                    'type': 'RESILIATION_MOBILE',
                    'actionList': [
                        {
                            'type': 'LINK',
                            'primary': true,
                            'label': 'En savoir plus sur la facture de clôture',
                            'uri': 'https://assistance.sfr.fr/nc/dernieres-factures-suite-a-une-resiliation.html',
                            'details': 'null'
                        }
                    ]
                }
            ]
        }
    }
}
